import { render, staticRenderFns } from "./Planting.vue?vue&type=template&id=32716206&"
import script from "./Planting.vue?vue&type=script&lang=js&"
export * from "./Planting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports